module.exports = __webpack_public_path__ + "images/emoji/passport_control.861539459392ee5857dc.png";